import { SqsQueueByFunction } from '@hud/portal-dtos/webapp-function.dto';
import { HudIcon } from '../../Icons/HudIcons';
import { NodeTitleWithIconContainer } from './NodeTitleWithIconContainer';


export function SQSQueueNodeBody({
  queue,
}: {
  queue: SqsQueueByFunction;
}) {
  const pathLabel = [
    queue.sqs_queue_name,
    queue.service.name,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <NodeTitleWithIconContainer
      title={queue.sqs_queue_name}
      icon={<HudIcon icon="entities.messageQueue" />}
      path={pathLabel}
    />
  );
}
